import * as selectors from './selectors'

export const ftBalancesSelectors = selectors
